module.exports = __webpack_public_path__ + "img/clubediario_header.a28f25cd.png";